const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';

  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const commercesApi = {
  list:        (opts)        => request('/commerces',                { query: opts }),
  get:         (id)          => request(`/commerces/${id}`),
  adminList:   (token, opts) => request('/admin/commerces',           { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/commerces/${id}`,     { token }),
  adminCreate: (token, body) => request('/admin/commerces',           { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/commerces/${id}`,     { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/commerces/${id}`,     { method: 'DELETE', token }),
};

export const COMMERCE_CATEGORIES = [
  { id: 'all',         lbl: 'Tous' },
  { id: 'restaurant',  lbl: 'Restaurants' },
  { id: 'boutique',    lbl: 'Boutiques' },
  { id: 'artisan',     lbl: 'Artisans' },
  { id: 'service',     lbl: 'Services' },
  { id: 'hebergement', lbl: 'Hébergement' },
  { id: 'marche',      lbl: 'Marché' },
];

export const CATEGORY_LABEL = Object.fromEntries(COMMERCE_CATEGORIES.map((c) => [c.id, c.lbl]));
